import React from 'react';
import Text from 'components/Text';
import Icon from 'components/Icon';
const FormInputWrapper = (props) => {
    return (React.createElement("div", { className: "labeled-input", "data-testid": "labeled-input" },
        React.createElement(Text.Base, null, props.label),
        React.createElement("div", { className: `input-wrapper ${(props === null || props === void 0 ? void 0 : props.icon) || (props === null || props === void 0 ? void 0 : props.textAsIcon) ? 'with-icon' : ''} 
        ${(props === null || props === void 0 ? void 0 : props.inputWrapperClassName) || ''}`, onClick: !props.loading ? props.onIconClick : undefined, "data-testid": "clickable-input-wrapper" },
            props.children,
            React.createElement("div", { className: "icon-wrapper not-clickable" }, props.loading ? (React.createElement(Icon.Spinner, null)) : (React.createElement(React.Fragment, null,
                props.icon && React.createElement(Icon.Base, { icon: props.icon }),
                props.textAsIcon && React.createElement(Text.Base, { color: "milkybrown" }, props.textAsIcon)))))));
};
export default FormInputWrapper;
